import type { Json, Tables } from "../../lib/database.types";
export const pageMeta = (
  page: Pick<Tables<"pages">, "seo">,
): Record<string, Json | undefined> =>
  page.seo && typeof page.seo === "object" && !Array.isArray(page.seo)
    ? page.seo
    : {};
export const isWork = (page: Pick<Tables<"pages">, "seo">) =>
  pageMeta(page).work === true;
export const isDeleted = (page: Pick<Tables<"pages">, "seo">) =>
  typeof pageMeta(page).deletedAt === "string";
// `reorder_pages` needs every page in the draft, trashed ones included. Trashed
// pages go after the given live order, keeping the order `pages` lists them in.
export const withTrashedPagesLast = (
  orderedIds: string[],
  pages: Pick<Tables<"pages">, "id" | "seo">[],
) => {
  const ordered = new Set(orderedIds);
  return [
    ...orderedIds,
    ...pages
      .filter((page) => isDeleted(page) && !ordered.has(page.id))
      .map((page) => page.id),
  ];
};
export const workDate =(page: Pick<Tables<"pages">, "seo">) =>
  typeof pageMeta(page).date === "string"
    ? (pageMeta(page).date as string)
    : "";
export const BASIC_LIMITS = { pages: 10, work: 100 };
export const workLabels = (settings: Json) => {
  const template =
    settings && typeof settings === "object" && !Array.isArray(settings)
      ? settings.template
      : "";
  return (
    (
      {
        portfolio: { plural: "Projects", singular: "project" },
        photography: { plural: "Photography", singular: "shoot" },
        apps: { plural: "Apps", singular: "app" },
        video: { plural: "Videos", singular: "video" },
      } as Record<string, { plural: string; singular: string }>
    )[String(template)] ?? { plural: "Work", singular: "work item" }
  );
};
